export const RECOMMENDATION_QUERY_OPTIONS = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  useErrorBoundary: false,
  retry: false
};
export const isTimeoutError = error => {
  const {
    code,
    message
  } = error ?? {};
  return code === 'ECONNABORTED' || /timeout/i.test(message ?? '');
};
//# sourceMappingURL=recommendationQuery.js.map